/**
 * Offline PLAYBACK engages only when the network is genuinely unavailable:
 * the browser says offline, or we observed the critical path stalling.
 *
 * Offline Mode (the learner's toggle) is deliberately NOT an input. Tom,
 * 2026-10-02: it means "prefer downloaded audio", not "only downloaded audio".
 * With it on and a reachable network, anything not downloaded plays from the
 * internet; the nothing-to-play notice needs no network AND nothing downloaded.
 */
export function isOfflinePlaybackActive(s: {
  browserOnline: boolean
  presumedDown: boolean
  leaseLocked: boolean
}): boolean {
  return (!s.browserOnline || s.presumedDown) && !s.leaseLocked
}
